/**
 * Creates an array of a given length and fills it with values returned by a function.
 */
export const fillArray = <T>({
  length,
  valueFn,
}: {
  length: number;
  valueFn: (index: number) => T;
}): T[] => {
  return Array.from({ length })
    .fill(null)
    .map((_, index) => valueFn(index));
};
